import { Image } from '@pata-app/ui-media';

import React from 'react';

import { getEnv } from '../../../../lib/utils/getEnv';
import {
  CalloutContainer,
  FeatureContainer,
  FeaturesContainer,
  FeatureSectionContainer,
  SectionTitle,
} from './featureSection.styled';

const { VITE_CDN_BASE_URL } = getEnv();

interface FeatureSectionProps {
  featureSection: {
    callout?: string;
    title: string;
    imageUrl: string;
    imageAltTag: string;
    features: {
      id: string;
      title: string;
      description: string;
      component?: any;
    }[];
  };
}

export function FeatureSection({ featureSection, rightAligned, index }: FeatureSectionProps) {
  return (
    <FeatureSectionContainer $rightAligned={rightAligned}>
      <Image
        alt={featureSection.imageAltTag}
        src={`${VITE_CDN_BASE_URL}/${featureSection.imageUrl}`}
        height={1000}
        width={1000}
      />

      <div>
        <SectionTitle>{featureSection.title}</SectionTitle>
        <FeaturesContainer>
          {featureSection.features.map((feature) => (
            <FeatureContainer>
              {feature.component ? (
                <feature.component />
              ) : (
                <>
                  <strong>{feature.title}</strong>
                  <p>{feature.description}</p>
                </>
              )}
            </FeatureContainer>
          ))}
        </FeaturesContainer>
        {Boolean(featureSection.callout) && <CalloutContainer>{featureSection.callout}</CalloutContainer>}
      </div>
    </FeatureSectionContainer>
  );
}
